const KEYS = {
  SELECTED: "selected",
  SELECTED_DELIMITER: "_",
  SELECTED_PEOPLE_DELIMITER: "-",
}

export default KEYS;
